__turbopack_context__.v({
  "badge": "DailySpecialSection-module__xqkqzG__badge",
  "body": "DailySpecialSection-module__xqkqzG__body",
  "card": "DailySpecialSection-module__xqkqzG__card",
  "cardLink": "DailySpecialSection-module__xqkqzG__cardLink",
  "cardTitle": "DailySpecialSection-module__xqkqzG__cardTitle",
  "container": "DailySpecialSection-module__xqkqzG__container",
  "content": "DailySpecialSection-module__xqkqzG__content",
  "cta": "DailySpecialSection-module__xqkqzG__cta",
  "ctaRow": "DailySpecialSection-module__xqkqzG__ctaRow",
  "excerpt": "DailySpecialSection-module__xqkqzG__excerpt",
  "eyebrow": "DailySpecialSection-module__xqkqzG__eyebrow",
  "footer": "DailySpecialSection-module__xqkqzG__footer",
  "header": "DailySpecialSection-module__xqkqzG__header",
  "image": "DailySpecialSection-module__xqkqzG__image",
  "imagePlaceholder": "DailySpecialSection-module__xqkqzG__imagePlaceholder",
  "imageWrap": "DailySpecialSection-module__xqkqzG__imageWrap",
  "price": "DailySpecialSection-module__xqkqzG__price",
  "section": "DailySpecialSection-module__xqkqzG__section",
  "takeawayTag": "DailySpecialSection-module__xqkqzG__takeawayTag",
});
